import React, { useEffect, useState } from "react"

import {
    Card,
    CardBody,
    Col,
    Row,
    CardTitle,
} from "reactstrap"

import { connect } from "react-redux";

//Import Action to copy breadcrumb items from local state to redux state
import { setBreadcrumbItems } from "../../store/actions";
import Loader from "components/Loader/Loader";
import { toast } from "react-toastify";
import { createCategory } from "helpers/category_helper";


const CreateCategory = (props) => {
    document.title = "Content Management | Create Category";




    const breadcrumbItems = [
        { title: "Category", link: "#" },
        { title: "Create Category", link: "#" },
    ]
    useEffect(() => {
        const blurDiv = document.getElementById("blur");
        var width = window.innerWidth;
        if (width <= 994) {
            blurDiv.click()
        }
    }, [])
    useEffect(() => {
        props.setBreadcrumbItems('Create Category', breadcrumbItems)
    })

    const [categoryName, setCategoryName] = useState("");
    const [categoryDescription, setCategoryDescription] = useState("");
    const [spanDisplay, setSpanDisplay] = useState("none");
    const [loader, setLoader] = useState(false);



    const handleSubmit = async (e) => {

        e.preventDefault();

        try {
            if (!categoryDescription || !categoryName) {
                setSpanDisplay("inline");
            }
            else {
                setLoader(true);
                const data = await createCategory({ name: categoryName, description: categoryDescription });
                setLoader(false);
                if (data?.success) {
                    toast.success(data?.message);
                    setCategoryDescription("");
                    setCategoryName("");
                }
                else {
                    toast.error(data?.message);
                }
            }
        } catch (error) {
            setLoader(false);
            toast.error(error?.response?.data?.message);
        }

    };


    return (
        <React.Fragment>
            {loader ? (
                <Loader />
            ) : ("")}
            <Row >
                <Col>
                    <Card>
                        <CardBody className="col-lg-10 col-sm-12 col-xs-12">
                            <CardTitle className="h4">Create Category</CardTitle>
                            <form onSubmit={handleSubmit}>

                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Category Name
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter new Category"
                                            value={categoryName}
                                            maxLength="50"
                                            onChange={(e) => setCategoryName(e.target.value)} />

                                        {!categoryName && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>
                                <Row className="mb-3">
                                    <label
                                        htmlFor="example-text-input"
                                        className="col-md-2 col-form-label"
                                    >
                                        Category Description
                                    </label>
                                    <div className="col-md-10">
                                        <input type="text"
                                            className='form-control'
                                            placeholder="Enter New Description"
                                            maxLength="50"
                                            value={categoryDescription}
                                            onChange={(e) => setCategoryDescription(e.target.value)} />
                                        {!categoryDescription && <span style={{ color: "red", display: spanDisplay }}>This feild is required</span>}
                                    </div>
                                </Row>


                                <Row className="mb-3">
                                    <div className="mt-4">
                                        <button type="submit" className="btn btn-primary w-md me-2">Create</button>
                                    </div>
                                </Row>
                            </form>

                        </CardBody>
                    </Card>
                </Col>
            </Row>



        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(CreateCategory);